import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-12 md:py-16 bg-wood-dark text-cream relative overflow-hidden wood-texture" data-id="element-86">
      <div className="absolute inset-0 bg-wood-dark/80 mix-blend-multiply" data-id="element-87"></div>
      <div className="container mx-auto px-4 relative z-10" data-id="element-88">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="max-w-3xl mx-auto border-2 border-amber rounded-2xl p-8 md:p-12 text-center bg-wood-dark/50 backdrop-blur-sm" data-id="element-89">
          <ShieldCheck className="w-16 h-16 text-amber mx-auto mb-4" data-id="element-90" />
          <h2 className="text-3xl md:text-4xl font-black text-white mb-4" data-id="element-91">
            GARANTÍA TOTAL — 7 DÍAS
          </h2>
          <p className="text-xl md:text-2xl font-bold text-amber-light mb-4" data-id="element-92">
            Si no es lo que esperabas: te devolvemos el 100%.
          </p>
          <p className="text-cream/70" data-id="element-93">
            Sin preguntas. Sin formularios. Sin drama.
          </p>
        </motion.div>
      </div>
    </section>;
}